export default __webpack_public_path__ + "static/media/AlbumImage.b3da2e8b.svg";